import React from 'react';
import { render } from 'react-dom';

import PapDetails from '../react/PapDetails';

export default class PapDetailsRender {
  constructor(context) {
    this.context = context;
    this.init();
  }

  init() {
    const { model } = this.context.dataset;
    if (!model) throw Error('Missing a required dataset');
    const jsonModel = JSON.parse(model);

    render(<PapDetails {...jsonModel} />, this.context);
  }
}
